<h2 mat-dialog-title *ngIf="data.title != null">{{data.title}}</h2>
<h2 mat-dialog-title *ngIf="data.title == null" i18n="@@confirmation-dialog_headline">Confirmation</h2>
<h3 class="mat-dialog-subheader" *ngIf="data.subheader != null">{{data.subheader}}</h3>
<div mat-dialog-content>
    <p>{{data.message}}</p>
</div>
<div mat-dialog-actions>
    <button mat-button [mat-dialog-close]="true">
        <span *ngIf="data.confirm_button_label != null">{{data.confirm_button_label}}</span>
        <span *ngIf="data.confirm_button_label == null" i18n="@@confirmation-dialog_confirmation-button">Yes</span>
    </button>
    <button mat-button [mat-dialog-close]="false" cdkFocusInitial>
        <span *ngIf="data.abort_button_label != null">{{data.abort_button_label}}</span>
        <span *ngIf="data.abort_button_label == null" i18n="@@confirmation-dialog_abort-button">No</span>
    </button>
</div>
